import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ValueAccessorHelper } from '@helpers/value-accessor-helper';
import { HttpBaseService } from '@service/http-base.service';
import { BeyondEMRConstants } from '../../../helpers/beyondemrconstants';
import { RoutingHelper } from '../../../helpers/routinghelper';
import { MatDialog } from '@angular/material/dialog';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { PersonalDetails } from '@models/masters/referring-provider.model';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { ApplySelfpayModel, PaymentMaster, ClaimPaymentModel, ClaimAdjustment } from '@models/payment/payment.model';
import { AmountValidationDialogComponent } from '../dialog/amountvalidation/amountvalidation.component';

@Component({
  selector: 'app-adjust-transaction',
  templateUrl: './adjust-transaction.component.html',
  styleUrls: ['./adjust-transaction.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: AdjustTransactionComponent, multi: true }
  ],
})

export class AdjustTransactionComponent extends ValueAccessorHelper<any> implements OnInit, OnChanges {

  @Input() ClaimId: number;
  @Input() adjustment: any[];
  @Input() apiURL: string;
  @Input() paymentId: number;
  @Input() balance: number;
  @Output() ifadjustment: EventEmitter<any> = new EventEmitter();
  @Output() claimadjustmentamount: EventEmitter<any> = new EventEmitter();
  adjustarray: any = [];
  claimadjustment: ClaimAdjustment;
  postURL: string;
  id: number = 0;
  patientId: number = 0;
  isInEdit: boolean = false;
  inputvalue: any
  patientStatus: any;
  PatientAppoinments: any;
  title: string = '';
  saveItem: any;
  filteredItems: any;
  selectedStatus: string;
  isChecked: boolean = true;
  providerDetail: PersonalDetails;
  adjustmentamount: number;
  adjustmentnotes: string = '';
  adjustmentType: number;
  action: string;
  myDate = new Date();
  ifnotes: boolean = false;
  ifamount: boolean = true;
  ifbalancenotes: boolean = false;
  ifbalanceamount: boolean = false;
  adjustmenttypename: string = '';

  constructor(private cdf: ChangeDetectorRef,
    private router: Router,
    public httpClient: HttpClient,
    public dialog?: MatDialog,
    private httpService?: HttpBaseService,
    private routingHelper?: RoutingHelper,
    private route?: ActivatedRoute,
    private fb?: FormBuilder,

  ) {
    super();
    this.claimadjustment = new ClaimAdjustment();

  }

  ngOnInit() {
    this.id = this.paymentId;
  }
  ngOnChanges() {

    this.cdf.detectChanges();
  }
  onSubmit(formElement: NgForm) {
    let isPreviousBalance = this.adjustmenttypename == 'Previous Balance' ? true : false;

    this.claimadjustment.ClaimId = this.ClaimId;
    this.claimadjustment.AdjustmentTypeId = this.adjustmentType;
    this.claimadjustment.PaymentDate = this.myDate;
    //this.claimadjustment.Amount = this.adjustmentamount ?? 0;
    this.claimadjustment.Amount = isPreviousBalance ? -this.adjustmentamount : this.adjustmentamount;
    this.claimadjustment.Notes = this.adjustmentnotes;
    this.claimadjustment.ClaimBalance = this.balance - this.claimadjustment.Amount;
    this.claimadjustment.AdjustmentTypeName = this.adjustmenttypename;
    this.postURL = this.apiURL + (isPreviousBalance ? `applyselfpay/UpdateOldAdjustmentType` : `applyselfpay/UpdateAdjustmentType`);

    if (this.adjustmentType != BeyondEMRConstants.Adjustmenttype.Note) {
      if (this.adjustmentamount == undefined || this.adjustmentamount == null || this.adjustmentamount <= 0 || !this.isValidAmount()) {
        const dialogRef = this.dialog.open(AmountValidationDialogComponent, {
          width: '400px',
          data: {
            amount: this.adjustmentamount,
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
        });
      }
      else {
        this.post();
      }
    }
    else {
      this.post();
    }
  }

  // isValidAmount(): boolean {
  //   return this.adjustmentamount <= this.balance;
  // }

  isValidAmount(): boolean {
    if (this.adjustmenttypename === 'Previous Balance') {
      return true;
    }
    return this.adjustmentamount <= this.balance;
  }


  post() {
    this.httpService.post(this.postURL, this.claimadjustment, true).subscribe(response => {
      this.claimadjustmentamount.emit(true);
    }, error => {
      if ((error.status === 400 || error.status === 401) || (error.status === 401 && error.statusText == 'Unauthorized')) {
        return false;
      }
    });
  }
  Paymentchange(event) {

  }
  onNoClick() {
    this.claimadjustmentamount.emit(false);
  }
  selectedValue(adjustmenttype) {
    this.adjustmenttypename = this.adjustment?.find(x => x.Id == adjustmenttype)?.DisplayName;
    if (adjustmenttype == BeyondEMRConstants.Adjustmenttype.Note) {
      this.ifnotes = true;
      this.ifamount = false;
    }
    else {
      this.ifnotes = false;
      this.ifamount = true;
    }
    if (adjustmenttype == BeyondEMRConstants.Adjustmenttype.Previous_ClaimBalance) {
      this.ifnotes = true;
      this.ifamount = false;
      this.ifbalanceamount = true;
    }
    else {
      this.ifbalanceamount = false;
    }
  }

}
